import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeeAndPaymentComponent } from './fee-and-payment/fee-and-payment.component';

const routes: Routes = [
  {
    path: '',
    component: FeeAndPaymentComponent,
  }
]


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyApplicationRoutingModule { }
